import addressee from '../../defaultFieldDefinitions/Addressee';
import addressLine2 from '../../defaultFieldDefinitions/AddressLine2';
import nameNumber from '../../defaultFieldDefinitions/HouseNameOrNumber';
import streetName from '../../defaultFieldDefinitions/StreetName';
import townCity from '../../defaultFieldDefinitions/TownCity';
import * as required from '../../required-validators';
import {fiveDigitsPostcodeValidator} from '../../setDigitsPostcodeValidator';

const FieldDefinitionFR = [
  addressee,
  {
    ...nameNumber,
    label: 'checkout.delivery.address.field.label.buildingNumberName.text',
  },
  {
    ...streetName,
    label: 'checkout.delivery.address.field.label.addressStreet.text',
  },
  {
    ...addressLine2,
    label: 'checkout.delivery.address.field.label.additionalAddressNumberOrFloor.text',
  },
  {
    name: 'postCode',
    label: 'checkout.delivery.address.field.label.postal.code.text',
    required: true,
    maxLength: 5,
    validate: [required.postCode, fiveDigitsPostcodeValidator],
  },
  townCity,
];

export default FieldDefinitionFR;
